module.exports = __webpack_public_path__ + "static/media/icon-chevron-down.cea067c3.svg";